import { CSSObject, useTheme } from '@core-ui/react-stitch';

const getTagLinkGroupStyles = (isBRColorChange): CSSObject => ({
  display: 'block',
  margin: 'auto',
  padding: '2rem 1rem',
  width: '100%',
  h2: {
    ...useTheme().brandFont,
    fontSize: '0.875rem'
  },
  a: {
    fontWeight: 350
  },
  ...(isBRColorChange && {
    '[data-testid="tag-link-group-heading"], [data-testid="tag-link-group-footer"] > button':
      {
        color: '#000000',
      },
    '& .tag-link-group__text': {
      'color': useTheme().color.b1,
      'backgroundColor': useTheme().color.inverse.b2,
      '&:hover': {
        backgroundColor: useTheme().color.inverse.g2,
        color: useTheme().color.wh,
      },
    },
  }),
});

export default getTagLinkGroupStyles;
